import { render, staticRenderFns } from "./baseInfoChangeV.vue?vue&type=template&id=6c8f0d20"
import script from "./baseInfoChangeV.vue?vue&type=script&lang=js"
export * from "./baseInfoChangeV.vue?vue&type=script&lang=js"
import style0 from "./baseInfoChangeV.vue?vue&type=style&index=0&id=6c8f0d20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports